import React, { memo, useLayoutEffect } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import { useRequestFilterSectionExpansion } from '../../../model/sectionExpansionContext';
import styles from './FilterSection.module.scss';

const FilterSection = ({
  heading,
  description,
  summary,
  icon,
  sectionId,
  activeCount = 0,
  collapsible = true,
  children,
  className,
}) => {
  const {
    expandedSections,
    setSectionExpanded,
    ensureSectionExpanded,
    hasStoredPreference,
  } = useRequestFilterSectionExpansion();
  const expanded = !collapsible || expandedSections[sectionId];

  useLayoutEffect(() => {
    if (collapsible && activeCount > 0 && !hasStoredPreference(sectionId)) {
      ensureSectionExpanded(sectionId);
    }
  }, [
    activeCount,
    collapsible,
    ensureSectionExpanded,
    hasStoredPreference,
    sectionId,
  ]);

  const headerContent = (
    <>
      <span className={styles.titleBlock}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <span className={styles.titleContent}>
          <span className={styles.heading}>{heading}</span>
          {description && (
            <span className={styles.description}>{description}</span>
          )}
          {summary && <span className={styles.summary}>{summary}</span>}
        </span>
      </span>

      <span className={styles.headerActions}>
        {activeCount > 0 && (
          <span className={styles.activeCount}>Активно: {activeCount}</span>
        )}
        {collapsible && (
          <button
            type="button"
            className={styles.expandButton}
            onClick={() => setSectionExpanded(sectionId, !expanded)}
            aria-expanded={expanded}
            aria-label={`${
              expanded ? 'Свернуть' : 'Развернуть'
            } секцию «${heading}»`}
          >
            <Icon type={expanded ? 'caret-up' : 'caret-down'} />
          </button>
        )}
      </span>
    </>
  );

  return (
    <section
      className={cn(styles.root, className, {
        [styles.active]: activeCount > 0,
      })}
    >
      <div className={styles.header}>{headerContent}</div>

      {expanded && <div className={styles.content}>{children}</div>}
    </section>
  );
};

export default memo(FilterSection);
